export enum ActionConstants {
  INIT_PORTAL_REQUEST = 'app/CbPortal/INIT_PORTAL_REQUEST',
  INIT_PORTAL_SUCCESS = 'app/CbPortal/INIT_PORTAL_SUCCESS',
  FETCH_PORTAL_REQUEST = 'app/CbPortal/FETCH_PORTAL_REQUEST',
  FETCH_PORTAL_SUCCESS = 'app/CbPortal/FETCH_PORTAL_SUCCESS',
}
